export const CURRENT_SETTING_CHANGED = "CURRENT_SETTING_CHANGED";
